document.addEventListener('DOMContentLoaded', () => {
  const quiz = window.LPM_MAROO_QUIZ_CHILD_DATA;

  if (!quiz) {
    console.warn('LPM Quiz enfant : données enfant introuvables.');
    return;
  }

  const root = document.getElementById('lpm-maroo-quiz-child');

  if (!root) {
    console.warn('LPM Quiz enfant : section introuvable.');
    return;
  }

  let currentQuestion = 0;
  let currentChildScene = 0;
  let answers = [];

  const screens = root.querySelectorAll('.lpm-maroo-screen');
  const questionContainer = root.querySelector('#lpm-child-question-container');
  const storyContainer = root.querySelector('#lpm-child-story-container');
  const resultHero = root.querySelector('#lpm-result-hero');

  const params = new URLSearchParams(window.location.search);
  const debugScreen = params.get('debug');
  const debugForce = params.get('force');

  const RESULT_PRODUCT_THEMES = {
    gardienne: { label: 'Gardienne', bg: '#eef3e1', accent: '#6f8f45' },
    inventrice: { label: 'Inventrice', bg: '#e6fbfb', accent: '#00939b' },
    exploratrice: { label: 'Exploratrice', bg: '#eee4ff', accent: '#7555b8' },
    chasseuse: { label: 'Chasseuse', bg: '#ffe2e2', accent: '#e85b6d' },
    diva: { label: 'Diva', bg: '#f1dcff', accent: '#8a4bd6' }
  };

  const RESULT_EMAIL_COPY = {
    gardienne: {
      title: 'Gardienne des Doudous',
      intro: 'Le Livre a reconnu une héroïne qui protège, console et prend soin des petits trésors oubliés.'
    },
    inventrice: {
      title: 'Inventrice de Merveilles',
      intro: 'Le Livre a reconnu une héroïne qui transforme les idées en surprises, les objets en inventions et les journées ordinaires en aventures.'
    },
    exploratrice: {
      title: 'Exploratrice des Mondes Enchantés',
      intro: 'Le Livre a reconnu une héroïne qui avance vers les mystères, les passages secrets et les nouveaux mondes à découvrir.'
    },
    chasseuse: {
      title: 'Chasseuse de Goûters Magiques',
      intro: 'Le Livre a reconnu une héroïne qui sait trouver les petits bonheurs, les douceurs cachées et les moments qui brillent.'
    },
    diva: {
      title: 'Diva des Paillettes',
      intro: 'Le Livre a reconnu une héroïne qui transforme chaque entrée en scène, chaque sourire en lumière et chaque détail en éclat.'
    }
  };

  function showScreen(name) {
    screens.forEach(screen => screen.classList.remove('is-active'));

    const target = root.querySelector(`[data-screen="${name}"]`);

    if (target) {
      target.classList.add('is-active');
    } else {
      console.warn(`LPM Quiz enfant : écran introuvable → ${name}`);
    }
  }

  function resetQuiz() {
    currentQuestion = 0;
    currentChildScene = 0;
    answers = [];
  }

  function getChildScenes() {
    return Array.isArray(quiz.scenes) ? quiz.scenes : [];
  }

  function getScoreTemplate() {
    return Object.keys(quiz.archetypes || {}).reduce((scores, id) => {
      scores[id] = 0;
      return scores;
    }, {});
  }

  function calculateScores() {
    const scores = getScoreTemplate();

    if (!Array.isArray(quiz.questions)) return scores;

    answers.forEach((answerIndex, questionIndex) => {
      const question = quiz.questions[questionIndex];

      if (!question || answerIndex === undefined || answerIndex === null) return;

      const answer = question.answers?.[answerIndex];

      if (!answer?.archetype) return;

      scores[answer.archetype] += question.weight || 1;
    });

    return scores;
  }

  function getSortedScores() {
    return Object.entries(calculateScores())
      .map(([id, score]) => ({ id, score }))
      .sort((a, b) => b.score - a.score);
  }

  function getDominantArchetype() {
    return getSortedScores()[0]?.id || null;
  }

  function getSecondaryArchetypes(winnerId) {
    const sorted = getSortedScores();
    const winnerScore = sorted.find(item => item.id === winnerId)?.score || 0;

    return sorted
      .filter(item => item.id !== winnerId)
      .filter(item => winnerScore - item.score <= 2)
      .slice(0, 2)
      .map(item => item.id);
  }

  function getDisplayedSecondaries(winnerId) {
    const secondaries = getSecondaryArchetypes(winnerId);

    const fallbackSecondaries = Object.keys(quiz.archetypes || {})
      .filter(id => id !== winnerId)
      .filter(id => !secondaries.includes(id));

    return [
      ...secondaries.slice(0, 2),
      ...fallbackSecondaries
    ].slice(0, 2);
  }

  function goToNextChildScene() {
    currentChildScene += 1;
    renderChildScene();
  }

  function bindStoryContinue() {
    if (!storyContainer) return;

    storyContainer
      .querySelectorAll('[data-action="continue-child-story"]')
      .forEach(button => {
        button.addEventListener('click', goToNextChildScene);
      });
  }

  function buildResponsiveImage({ desktop, mobile, alt, className, loading = 'eager' }) {
  if (!desktop && !mobile) return '';

  const src = desktop || mobile;

  return `
    <picture>
      ${mobile ? `<source media="(max-width: 768px)" srcset="${mobile}">` : ''}
      <img
        src="${src}"
        alt="${alt || ''}"
        class="${className || ''}"
        loading="${loading}"
      >
    </picture>
  `;
}

  function renderChildScene() {
    const scenes = getChildScenes();
    const scene = scenes[currentChildScene];

    if (!scene) {
      renderResult();
      return;
    }

    if (scene.type === 'story') {
      renderChildStoryScene(scene);
      return;
    }

    if (scene.type === 'question') {
      currentQuestion = scene.questionIndex;
      renderQuestion();
      return;
    }

    if (scene.type === 'result') {
      renderResult();
      return;
    }

    console.warn(`LPM Quiz enfant : type de scène inconnu → ${scene.type}`);
    goToNextChildScene();
  }

 function renderChildStoryScene(scene) {
  const storyImages = quiz.storyVisuals?.[scene.id];

  if (storyImages) {
    storyContainer.innerHTML = `
      <div class="lpm-maroo-interlude-visual">
        ${buildResponsiveImage({
          desktop: storyImages.desktop,
          mobile: storyImages.mobile,
          alt: 'Écran narratif enfant Les Petits Maroo',
          className: 'lpm-maroo-interlude-image',
          loading: 'eager'
        })}

        <button
          type="button"
          class="lpm-maroo-interlude-hotspot lpm-maroo-child-screen-${scene.id}"
          data-action="continue-child-story"
          aria-label="Continuer l’enquête"
        ></button>
      </div>
    `;

    bindStoryContinue();
    showScreen('story');
    return;
  }

  storyContainer.innerHTML = `
    <div class="lpm-maroo-card">
      <p>Écran narratif enfant introuvable : ${scene.id}</p>
      <button type="button" class="lpm-maroo-btn" data-action="continue-child-story">
        Continuer
      </button>
    </div>
  `;

  bindStoryContinue();
  showScreen('story');
}

function renderQuestion() {
  if (!Array.isArray(quiz.questions)) {
    console.warn('LPM Quiz enfant : questions introuvables.');
    return;
  }

  const question = quiz.questions[currentQuestion];

  if (!question) {
    renderResult();
    return;
  }

  const questionNumber = currentQuestion + 1;
  const questionImages = quiz.questionVisuals?.[questionNumber];

  if (questionImages) {
    questionContainer.innerHTML = `
      <div class="lpm-maroo-question-visual">
        ${buildResponsiveImage({
          desktop: questionImages.desktop,
          mobile: questionImages.mobile,
          alt: 'Question enfant du quiz Les Petits Maroo',
          className: 'lpm-maroo-question-image',
          loading: 'eager'
        })}

        <button type="button" class="lpm-maroo-question-hotspot lpm-maroo-child-q${questionNumber}-a" data-answer-index="0" aria-label="Réponse A"></button>
        <button type="button" class="lpm-maroo-question-hotspot lpm-maroo-child-q${questionNumber}-b" data-answer-index="1" aria-label="Réponse B"></button>
        <button type="button" class="lpm-maroo-question-hotspot lpm-maroo-child-q${questionNumber}-c" data-answer-index="2" aria-label="Réponse C"></button>
        <button type="button" class="lpm-maroo-question-hotspot lpm-maroo-child-q${questionNumber}-d" data-answer-index="3" aria-label="Réponse D"></button>
      </div>
    `;

    questionContainer
      .querySelectorAll('.lpm-maroo-question-hotspot')
      .forEach(button => {
        button.addEventListener('click', () => {
          selectAnswer(Number(button.dataset.answerIndex));
        });
      });

    showScreen('question');
    return;
  }

  questionContainer.innerHTML = `
    <div class="lpm-maroo-card">
      <div class="lpm-maroo-question-meta">
        <span>Question ${questionNumber} / ${quiz.questions.length}</span>
      </div>

      <h2 class="lpm-maroo-question-title">
        ${question.title || ''}
      </h2>

      <div class="lpm-maroo-answers">
        ${(question.answers || []).map((answer, index) => `
          <button
            type="button"
            class="lpm-maroo-answer"
            data-answer-index="${index}"
          >
            ${answer.text || ''}
          </button>
        `).join('')}
      </div>
    </div>
  `;

  questionContainer
    .querySelectorAll('[data-answer-index]')
    .forEach(button => {
      button.addEventListener('click', () => {
        selectAnswer(Number(button.dataset.answerIndex));
      });
    });

  showScreen('question');
}

  function selectAnswer(answerIndex) {
    answers[currentQuestion] = answerIndex;
    goToNextChildScene();
  }

  function getResultProducts(archetypeId) {
    const source = window.LPM_CHILD_RESULT_PRODUCTS || {};
    const products = source[archetypeId] || [];

    if (products.length) return products.slice(0, 6);

    return Array.from({ length: 6 }).map((_, index) => ({
      title: `Trésor ${String(index + 1).padStart(2, '0')}`,
      price: '',
      image: '',
      url: '#',
      variantId: null,
      reason: 'Trésor retrouvé par le Livre dans une histoire qui te ressemble.'
    }));
  }

  function getResultHeroTemplate(archetypeId) {
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  const images = quiz.resultHeroes?.[archetypeId] || {};
  const src = isMobile && images.mobile ? images.mobile : images.desktop;

  if (!src) return null;

  const template = document.createElement('div');
  template.innerHTML = `
    <picture>
      ${images.mobile ? `<source media="(max-width: 768px)" srcset="${images.mobile}">` : ''}
      <img
        src="${src}"
        alt="Résultat enfant du quiz Les Petits Maroo"
        class="lpm-result-hero-image"
        loading="eager"
      >
    </picture>
  `;

  return template;
}

  function getResultDossierTemplate(archetypeId) {
  const isMobile = window.matchMedia('(max-width: 768px)').matches;
  const images = quiz.resultDossiers?.[archetypeId] || {};
  const src = isMobile && images.mobile ? images.mobile : images.desktop;

  if (!src) return null;

  const template = document.createElement('div');
  template.innerHTML = `
    <picture>
      ${images.mobile ? `<source media="(max-width: 768px)" srcset="${images.mobile}">` : ''}
      <img
        src="${src}"
        alt="Fiche résultat enfant Les Petits Maroo"
        class="lpm-result-dossier-image"
        loading="lazy"
      >
    </picture>
  `;

  return template;
}

  function getResultMainBoardUrl(archetypeId) {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const board = window.LPM_CHILD_RESULT_PRODUCT_BOARDS?.[archetypeId] || {};

    return isMobile && board.mobile ? board.mobile : board.desktop || '';
  }

  function getResultSecondaryBoardPicture() {
    const board = window.LPM_CHILD_RESULT_SECONDARY_BOARD || {};

    return `
      <picture class="lpm-result-secondary-bg">
        ${board.mobile ? `<source media="(max-width:768px)" srcset="${board.mobile}">` : ''}
        ${board.desktop ? `<img src="${board.desktop}" alt="D’autres trésors retrouvés pour toi">` : ''}
      </picture>
    `;
  }

  function getFlatImageFromPicture(html) {
    const temp = document.createElement('div');
    temp.innerHTML = html || '';

    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const source = isMobile ? temp.querySelector('source') : null;
    const img = temp.querySelector('img');

    return source?.getAttribute('srcset') || img?.getAttribute('src') || '';
  }

  function getResultBannerImage(archetypeId, level) {
  return quiz.resultBanners?.[archetypeId]?.[level] || '';
}

  function ensureProductModal() {
    let modal = document.getElementById('lpm-result-product-modal');

    if (modal) return modal;

    modal = document.createElement('div');
    modal.id = 'lpm-result-product-modal';
    modal.className = 'lpm-result-product-modal';
    modal.innerHTML = `
      <div class="lpm-result-product-modal-backdrop" data-action="close-product-modal"></div>

      <div class="lpm-result-product-modal-card">
        <button type="button" class="lpm-result-product-modal-close" data-action="close-product-modal">×</button>

        <div class="lpm-result-product-modal-image"></div>

        <div class="lpm-result-product-modal-copy">
          <p class="lpm-result-product-modal-kicker"></p>
          <h3></h3>
          <p class="lpm-result-product-modal-reason"></p>
          <p class="lpm-result-product-modal-price"></p>

          <button type="button" class="lpm-result-product-modal-cart">
            Ajouter au panier
          </button>

          <a class="lpm-result-product-modal-link" href="#">
            Voir la fiche complète
          </a>
        </div>
      </div>
    `;

    document.body.appendChild(modal);

    modal.querySelectorAll('[data-action="close-product-modal"]').forEach(button => {
      button.addEventListener('click', closeProductModal);
    });

    return modal;
  }

  function openProductModal(product, index, archetypeId) {
    const modal = ensureProductModal();
    const theme = RESULT_PRODUCT_THEMES[archetypeId] || RESULT_PRODUCT_THEMES.gardienne;

    modal.style.setProperty('--lpm-product-modal-bg', theme.bg);
    modal.style.setProperty('--lpm-product-modal-accent', theme.accent);

    modal.querySelector('.lpm-result-product-modal-kicker').textContent =
      `Trésor retrouvé n°${String(index + 1).padStart(2, '0')}`;

    modal.querySelector('h3').textContent = product.title || '';
    modal.querySelector('.lpm-result-product-modal-reason').textContent = product.reason || '';
    modal.querySelector('.lpm-result-product-modal-price').textContent = product.price || '';

    const imageBox = modal.querySelector('.lpm-result-product-modal-image');
    imageBox.innerHTML = product.image
      ? `<img src="${product.image}" alt="${product.title || ''}">`
      : '';

    const link = modal.querySelector('.lpm-result-product-modal-link');
    link.href = product.url || '#';

    const cartButton = modal.querySelector('.lpm-result-product-modal-cart');

    cartButton.onclick = () => {
      if (!product.variantId) return;
      addResultProductToCart(product.variantId);
    };

    cartButton.disabled = !product.variantId;
    cartButton.textContent = product.variantId ? 'Ajouter au panier' : 'Produit à connecter';

    modal.classList.remove('lpm-result-product-modal--adult');
    modal.classList.add('lpm-result-product-modal--child');
    modal.classList.add('is-open');
  }

  function closeProductModal() {
    const modal = document.getElementById('lpm-result-product-modal');
    if (modal) modal.classList.remove('is-open');
  }

  function addResultProductToCart(variantId) {
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 })
    })
      .then(response => response.json())
      .then(() => {
        document.dispatchEvent(new CustomEvent('cart:refresh'));
      })
      .catch(error => {
        console.warn('Ajout panier impossible :', error);
      });
  }

  function isValidEmail(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(String(email || '').trim());
  }

  function setResultEmailMessage(messageBox, text, type) {
    if (!messageBox) return;

    messageBox.textContent = text || '';
    messageBox.classList.remove('is-visible', 'is-error', 'is-success');

    if (!text) return;

    messageBox.classList.add('is-visible');

    if (type === 'error') messageBox.classList.add('is-error');
    if (type === 'success') messageBox.classList.add('is-success');
  }

  function buildResultEmailPayload({ email, winnerId, secondaries }) {
    const secondaryOneId = secondaries?.[0] || '';
    const secondaryTwoId = secondaries?.[1] || '';

    const winnerCopy = RESULT_EMAIL_COPY[winnerId] || {};
    const secondaryOneCopy = RESULT_EMAIL_COPY[secondaryOneId] || {};
    const secondaryTwoCopy = RESULT_EMAIL_COPY[secondaryTwoId] || {};

    return {
      email,
      universe: 'child',

      result: winnerId,
      resultName: quiz?.archetypes?.[winnerId]?.name || winnerCopy.title || winnerId,
      resultEmailTitle: winnerCopy.title || quiz?.archetypes?.[winnerId]?.name || winnerId,
      resultEmailIntro: winnerCopy.intro || '',

      secondaryOne: secondaryOneId,
      secondaryOneName: quiz?.archetypes?.[secondaryOneId]?.name || secondaryOneCopy.title || secondaryOneId,
      secondaryOneEmailTitle: secondaryOneCopy.title || quiz?.archetypes?.[secondaryOneId]?.name || secondaryOneId,
      secondaryOneEmailIntro: secondaryOneCopy.intro || '',

      secondaryTwo: secondaryTwoId,
      secondaryTwoName: quiz?.archetypes?.[secondaryTwoId]?.name || secondaryTwoCopy.title || secondaryTwoId,
      secondaryTwoEmailTitle: secondaryTwoCopy.title || quiz?.archetypes?.[secondaryTwoId]?.name || secondaryTwoId,
      secondaryTwoEmailIntro: secondaryTwoCopy.intro || '',

      mainProducts: getResultProducts(winnerId).slice(0, 6).map(product => ({
        title: product.title || '',
        price: product.price || '',
        url: product.url || '',
        image: product.image || ''
      })),

      secondaryOneProducts: secondaryOneId
        ? getResultProducts(secondaryOneId).slice(0, 3).map(product => ({
            title: product.title || '',
            price: product.price || '',
            url: product.url || '',
            image: product.image || ''
          }))
        : [],

      secondaryTwoProducts: secondaryTwoId
        ? getResultProducts(secondaryTwoId).slice(0, 3).map(product => ({
            title: product.title || '',
            price: product.price || '',
            url: product.url || '',
            image: product.image || ''
          }))
        : [],

      createdAt: new Date().toISOString()
    };
  }

  function bindResultEmailForm({ emailCard, winnerId, secondaries }) {
    if (!emailCard) return;

    const input = emailCard.querySelector('[data-result-email-input]');
    const button = emailCard.querySelector('[data-action="send-result-email"]');
    const messageBox = emailCard.querySelector('[data-result-email-message]');

    const shopifyForm = root.querySelector('#lpm-result-shopify-email-form');
    const shopifyEmail = root.querySelector('#lpm-result-shopify-email');
    const shopifyTags = root.querySelector('#lpm-result-shopify-tags');

    if (!input || !button) return;

    button.addEventListener('click', () => {
      const email = input.value.trim();

      if (!email) {
        setResultEmailMessage(
          messageBox,
          'Écris ton email pour recevoir ton aventure.',
          'error'
        );
        return;
      }

      if (!isValidEmail(email)) {
        setResultEmailMessage(
          messageBox,
          'Cet email ne semble pas valide.',
          'error'
        );
        return;
      }

      const payload = buildResultEmailPayload({
        email,
        winnerId,
        secondaries
      });

      localStorage.setItem(
        'lpm_maroo_quiz_email_payload',
        JSON.stringify(payload)
      );

      const tags = [
        'quiz-maroo',
        'quiz-enfant',
        `resultat-${winnerId}`,
        secondaries?.[0] ? `influence-forte-${secondaries[0]}` : '',
        secondaries?.[1] ? `influence-moderee-${secondaries[1]}` : ''
      ].filter(Boolean).join(', ');

      if (shopifyForm && shopifyEmail && shopifyTags) {
        shopifyEmail.value = email;
        shopifyTags.value = tags;

        if (typeof shopifyForm.requestSubmit === 'function') {
          shopifyForm.requestSubmit();
          return;
        }

        shopifyForm.submit();
        return;
      }

      setResultEmailMessage(
        messageBox,
        'Impossible de transmettre le dossier pour le moment.',
        'error'
      );
    });
  }

  function getExploreItem(archetypeId) {
  const template = quiz.exploreTemplates?.[archetypeId];

  if (!template) return null;

  const builderData = window.LPM_EXPLORE_DATA?.child?.[archetypeId] || {};

  return {
    templateDesktop: template.desktop || '',
    templateMobile: template.mobile || '',
    collectionImage: builderData.collectionImage || '',
    url: builderData.url || '#'
  };
}

  function renderResultExplore({ container, winnerId, secondaries }) {
    if (!container) return;

    const rawSecondaries = Array.isArray(secondaries)
      ? secondaries.filter(Boolean).slice(0, 2)
      : [];

    const fallbackSecondaries = Object.keys(quiz?.archetypes || {})
      .filter(id => id !== winnerId)
      .filter(id => !rawSecondaries.includes(id));

    const ids = [
      winnerId,
      ...rawSecondaries,
      ...fallbackSecondaries
    ].filter(Boolean).slice(0, 3);

    const isMobile = window.matchMedia('(max-width: 768px)').matches;

    const templateItem = getExploreItem(winnerId);
    const templateUrl = templateItem
      ? (isMobile && templateItem.templateMobile ? templateItem.templateMobile : templateItem.templateDesktop)
      : '';

    if (!templateUrl) {
      container.innerHTML = '';
      return;
    }

    container.innerHTML = `
      <div class="lpm-result-explore-card lpm-result-explore-card--child lpm-result-explore-card--${winnerId}">

        ${ids.map((id, index) => {
          const item = getExploreItem(id);
          if (!item) return '';

          return `
            <div class="lpm-result-explore-collection lpm-result-explore-slot-${index + 1}">
              ${item.collectionImage ? `<img src="${item.collectionImage}" alt="">` : ''}
            </div>
          `;
        }).join('')}

        <img
          class="lpm-result-explore-template"
          src="${templateUrl}"
          alt="Continuer l’exploration"
        >

        ${ids.map((id, index) => {
          const item = getExploreItem(id);
          if (!item) return '';

          return `
            <a
              class="lpm-result-explore-hotspot lpm-result-explore-hotspot-${index + 1}"
              href="${item.url || '#'}"
              aria-label="Continuer l’exploration"
            ></a>
          `;
        }).join('')}

      </div>
    `;
  }

  function renderResult() {
    const winnerId = debugForce || getDominantArchetype() || 'gardienne';
    const secondaries = getDisplayedSecondaries(winnerId);

    const heroTemplate = getResultHeroTemplate(winnerId);
    const dossierTemplate = getResultDossierTemplate(winnerId);

    const dossierContainer = root.querySelector('#lpm-result-dossier');
    const productsContent = root.querySelector('#lpm-products-content');
    const secondaryContainer = root.querySelector('#lpm-result-secondary');
    const emailCard = root.querySelector('#lpm-result-email-card');
    const exploreContainer = root.querySelector('#lpm-result-explore');

    if (heroTemplate && resultHero) {
      resultHero.innerHTML = heroTemplate.innerHTML;
    }

    if (dossierTemplate && dossierContainer) {
      dossierContainer.innerHTML = dossierTemplate.innerHTML;
    }

    if (productsContent) {
      const resultProducts = getResultProducts(winnerId);
      const mainBoardUrl = getResultMainBoardUrl(winnerId);

      productsContent.innerHTML = `
        <div class="lpm-result-archive-board lpm-result-archive-board--child lpm-result-archive-board--${winnerId}">

          <div class="lpm-result-archive-products">
            ${resultProducts.map((product, index) => `
              <div class="lpm-result-archive-product lpm-result-archive-product-${index + 1}">
                ${product.image ? `<img src="${product.image}" alt="${product.title || ''}">` : ''}
              </div>
            `).join('')}
          </div>

          ${mainBoardUrl ? `
            <img
              class="lpm-result-archive-bg"
              src="${mainBoardUrl}"
              alt="Les trésors retrouvés dans ton aventure"
            >
          ` : ''}

          ${resultProducts.map((product, index) => `
            <button
              type="button"
              class="lpm-result-archive-hotspot lpm-result-archive-hotspot-${index + 1}"
              data-product-index="${index}"
              aria-label="Consulter ${product.title || 'ce produit'}"
            ></button>
          `).join('')}

        </div>
      `;

      productsContent.onclick = (event) => {
        const card = event.target.closest('.lpm-result-archive-hotspot');
        if (!card) return;

        const index = Number(card.dataset.productIndex);
        openProductModal(resultProducts[index], index, winnerId);
      };
    }

    if (secondaryContainer) {
      secondaryContainer.innerHTML = secondaries.map((id, index) => {
        const item = quiz.archetypes?.[id] || {};
        const influenceProducts = getResultProducts(id).slice(0, 3);
        const bannerLevel = index === 0 ? 'high' : 'moderate';
        const bannerImage = getResultBannerImage(id, bannerLevel);

        return `
          <article class="lpm-result-influence-card lpm-result-influence-card--child lpm-result-influence-card--${id}">

            <div class="lpm-result-child-secondary-row">

              <div class="lpm-result-child-secondary-banner">
                ${bannerImage ? `<img src="${bannerImage}" alt="${item.name || ''}">` : ''}
              </div>

              <div class="lpm-result-secondary-board lpm-result-secondary-board--child">
                <img
                  class="lpm-result-secondary-bg"
                  src="${getFlatImageFromPicture(getResultSecondaryBoardPicture())}"
                  alt="D’autres trésors retrouvés pour toi"
                >

                <div class="lpm-result-secondary-products">
                  ${influenceProducts.map((product, productIndex) => `
                    <div class="lpm-result-secondary-product lpm-result-secondary-product-${productIndex + 1}">
                      ${product.image ? `<img src="${product.image}" alt="${product.title || ''}">` : ''}
                    </div>
                  `).join('')}
                </div>

                ${influenceProducts.map((product, productIndex) => `
                  <button
                    type="button"
                    class="lpm-result-secondary-hotspot lpm-result-secondary-hotspot-${productIndex + 1}"
                    data-influence-id="${id}"
                    data-product-index="${productIndex}"
                    aria-label="Consulter ${product.title || 'ce produit'}"
                  ></button>
                `).join('')}

              </div>

            </div>

          </article>
        `;
      }).join('');

      secondaryContainer.onclick = (event) => {
        const card = event.target.closest('.lpm-result-secondary-hotspot');
        if (!card) return;

        const archetypeId = card.dataset.influenceId;
        const index = Number(card.dataset.productIndex);
        const products = getResultProducts(archetypeId).slice(0, 3);

        openProductModal(products[index], index, archetypeId);
      };
    }

    if (emailCard) {
      const emailImage = window.LPM_CHILD_RESULT_EMAIL_IMAGE || {};

      emailCard.className = 'lpm-result-email-card lpm-result-email-card--child';

      emailCard.innerHTML = `
        <div class="lpm-result-archives-card">

          ${
            emailImage.desktop || emailImage.mobile
              ? `
                <picture>
                  ${
                    emailImage.mobile
                      ? `<source media="(max-width: 768px)" srcset="${emailImage.mobile}">`
                      : ''
                  }

                  ${
                    emailImage.desktop
                      ? `<img
                          src="${emailImage.desktop}"
                          alt="Recevoir mon chapitre secret"
                        >`
                      : ''
                  }
                </picture>
              `
              : ''
          }

          <input
            type="email"
            class="lpm-result-archives-input"
            data-result-email-input
            placeholder="Email"
            aria-label="Adresse email"
            autocomplete="email"
          >

          <button
            type="button"
            class="lpm-result-archives-button"
            data-action="send-result-email"
            aria-label="M’envoyer mon chapitre secret"
          ></button>

          <p
            class="lpm-result-archives-message"
            data-result-email-message
            aria-live="polite"
          ></p>

        </div>
      `;

      bindResultEmailForm({
        emailCard,
        winnerId,
        secondaries
      });
    }

    if (exploreContainer) {
      renderResultExplore({
        container: exploreContainer,
        winnerId,
        secondaries
      });
    }

    localStorage.setItem('lpm_maroo_quiz_result', JSON.stringify({
      universe: 'child',
      result: winnerId,
      secondary: secondaries,
      answers
    }));

    showScreen('result');
  }

  function prepareDebugAnswers(length) {
    answers = Array.from({ length }, (_, index) => {
      const question = quiz.questions?.[index];
      return question?.answers?.length ? 0 : null;
    });
  }

  function runDebugMode() {
    if (!debugScreen) return false;

    resetQuiz();

    

    const forcedChildScreenMatch = debugScreen.match(/^child-screen-e(\d{2})$/);

    if (forcedChildScreenMatch) {
      const screenNumber = forcedChildScreenMatch[1];
      const sceneIndex = getChildScenes().findIndex(
        scene => scene.id === `e${screenNumber}`
      );

      if (sceneIndex === -1) {
        console.warn(`LPM Quiz enfant : écran debug introuvable → e${screenNumber}`);
        renderChildScene();
        return true;
      }

      currentChildScene = sceneIndex;
      renderChildScene();
      return true;
    }

    const questionMatch = debugScreen.match(/^question-(\d+)$/);

    if (questionMatch) {
      const requestedQuestion = Number(questionMatch[1]);
      const maxQuestion = quiz.questions.length;

      currentQuestion = Math.min(Math.max(requestedQuestion, 1), maxQuestion) - 1;
      prepareDebugAnswers(currentQuestion);

      renderQuestion();
      return true;
    }

    if (debugScreen === 'result') {
      prepareDebugAnswers(quiz.questions.length);
      currentQuestion = quiz.questions.length;
      renderResult();
      return true;
    }

    console.warn(`LPM Quiz enfant : debug inconnu → ${debugScreen}`);
    showScreen('intro-child');
    return true;
  }

  if (runDebugMode()) return;

  resetQuiz();
  renderChildScene();
  });
